/**
 * Reusable stateless form component for Metric
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { 
  CheckboxInput
  , NumberInput 
  , RadioInput
  , SelectFromObject
  , SelectFromArray
  , TextInput
  , TextAreaInput
} from '../../../global/components/forms';

function MetricForm({
  cancelLink
  , formHelpers 
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , metric
  , metricCategories
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Metric" : "Update Metric";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="metricForm" className="metric-form" onSubmit={handleFormSubmit}>
            {header}
            <TextAreaInput
              name="metric.title"
              label="Metric"
              value={metric.title}
              change={handleFormChange}
              placeholder="Define the metric to be tracked here..."
              required={true}
            />
            <div className="yt-col full m_50">
              <SelectFromObject
                change={handleFormChange}
                clearable={false}
                disabled={!metricCategories}
                display={'title'}
                filterable={true}
                helpText={ <em><small> Don't see your category? <Link to="/admin/authoring/metric-categories/new">Create a new one</Link></small></em>}
                label="Category"
                name="metric._metricCategory"
                objects={metricCategories}
                placeholder="-- Select a Category --"
                required={false}
                selected={metric._metricCategory}
                value={'_id'}
              />
            </div>
            <div className="yt-col full s_50 m_25">
              <NumberInput
                name="metric.order"
                label="Sort order"
                helpText="Used for setting the order on the reports"
                step="1"
                value={metric.order}
                change={handleFormChange}
              />
            </div>
            
            <CheckboxInput
              change={handleFormChange}
              checked={metric.survey}
              label="This metric applies to a survey?"
              name="metric.survey"
              value={metric.survey}
              tooltipText={"If checked this metric will be scored as a survey response"}
            />
            <CheckboxInput
              change={handleFormChange}
              checked={metric.pretest}
              label="This metric is part of a pretest?"
              name="metric.pretest"
              value={metric.pretest}
              tooltipText={"If checked this metric will be calculated as part of a program pretest score"}
            />
            <RadioInput
              label="This metrics has a Likelihood of Deviation Occurring (LDO) score?"
              options={[
                {val: 'no', display: 'No'},
                {val: 'yes', display: 'Yes, has an LDO score'},
              ]}
              name="formHelpers.hasLDO"
              value={formHelpers.hasLDO}
              change={handleFormChange}
              inLine={false}
            />
            {formHelpers.hasLDO === 'yes' ?
              <div className="yt-col full s_50 m_25">
                <SelectFromArray
                  change={handleFormChange}
                  items={[1,2,3]}
                  label="LDO score"
                  name="metric.likelihoodDeviation"
                  value={metric.likelihoodDeviation}
                />
              </div>
              :
              null 
            }
            <RadioInput
              label="This metrics has an Impact of Non-Compliance (INC) score?"
              options={[
                {val: 'no', display: 'No'},
                {val: 'yes', display: 'Yes, has an INC score'},
              ]}
              name="formHelpers.hasINC"
              value={formHelpers.hasINC}
              change={handleFormChange}
              inLine={false}
            />
            {formHelpers.hasINC === 'yes' ?
              <div className="yt-col full s_50 m_25">
                <SelectFromArray
                  name="metric.impactNonCompliance"
                  label="INC score"
                  items={[1,2,3]}
                  value={metric.impactNonCompliance}
                  change={handleFormChange}
                />
              </div>
              :
              null
            }
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

MetricForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formHelpers: PropTypes.object 
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , metric: PropTypes.object.isRequired
  , metricCategories: PropTypes.array
}

MetricForm.defaultProps = {
  formHelpers: {}
  , formTitle: ''
  , metricCategories: []
}

export default MetricForm;



// WEBPACK FOOTER //
// modules/metric/components/MetricForm.js.jsx